const Loader = ({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) => {
  const sizeClasses = {
    sm: 'h-2 w-2',
    md: 'h-2.5 w-2.5',
    lg: 'h-3 w-3',
  }

  const circleClass = `${sizeClasses[size]} bg-current rounded-full`

  return (
    <div className="flex items-center gap-1">
      <div className={`${circleClass} animate-bounce`} />
      <div className={`${circleClass} animate-bounce200`} />
      <div className={`${circleClass} animate-bounce400`} />
    </div>
  )
}

export default Loader
